webpackJsonp([263791100135453],{

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Layout = __webpack_require__(19);
	
	var _Typography = __webpack_require__(24);
	
	var _StyledLink = __webpack_require__(50);
	
	var _SocialLinks = __webpack_require__(65);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AboutPage = function AboutPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'article',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'About \u2022 ',
	        data.site.siteMetadata.title
	      )
	    ),
	    _react2.default.createElement(
	      'header',
	      null,
	      _react2.default.createElement(
	        _Typography.Title,
	        { fontSize: [4, 5], fontWeight: '7', lineHeight: 'title', mt: 0, mb: 3 },
	        'About'
	      ),
	      _react2.default.createElement(_Typography.Rule, { mt: 4, mb: 5 })
	    ),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 0, mb: 3 },
	        'About Me'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'My dad introduced me to an Epson PC with an Intel 8088 processor on which I\'ve learned to write spaghetti code in GW-BASIC. This started my fascination with programming languages. This fascination led me to various languages following different programming paradigms. I especially enjoyed Pascal, C, Java, Python, LISP, and Scala.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Since then, I\u2019ve been developing software and building infrastructure professionally for almost 25\xA0years and I\u2019ve seen many things in IT changing drastically while others staying very much the same. I\u2019ve seen new things become old and old things become new again. In a way, there\'s always something new and old to learn.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Today, I\u2019m interested in all things coding, devops, and site reliability. I\u2019m also very much into software engineering and agile software development processes. I write most of my code in different DSLs like Ansible and Terraform. When in doubt, I drop back to my currently favorite language Rust.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'I\u2019m currently living in Germany. If you like to get in touch, you can find me on ',
	        _react2.default.createElement(_SocialLinks.SocalLinks, null),
	        '.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'About My Work'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'During my professional career I\u2019ve had the opportunity to work on a variety of challenging projects as freelancer, consultant, scientific researcher, and product developer.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'My first paid job in IT has been with a local Internet Service Provider in 1994 where I managed Linux and Windows NT servers. Since then I\u2019ve worked for Nokia, T-Mobile, Metro AG, Metro Systems, the German Federal Office for Information Security (BSI), Norman (now AVG), the German national researcher society Fraunhofer and especially its department for Cyber Analysis and Defense, the German Research Foundation (DFG), and other exciting companies, organizations, and projects.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'Currently, I\u2019m Chief Information Officer (CIO) and board member at',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://scopevisio.com',
	          text: 'Scopevisio',
	          external: true
	        }),
	        ' ',
	        'as well as Managing Director at',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://centerdevice.de',
	          text: 'CenterDevice',
	          external: true
	        }),
	        ', where we develop cutting-edge cloud-based software services for enterprises.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'I hold a masters degree in Computer Science from the University of Bonn where I also received my PhD. I\u2019m a certified data protection officer as well as information security officer.'
	      ),
	      _react2.default.createElement(
	        _Typography.Subtitle,
	        { fontSize: [3, 4], mt: 4, mb: 3 },
	        'About This Site'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        'This site has been build with the static site generator',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://www.gatsbyjs.org',
	          text: 'Gatsby',
	          external: true
	        }),
	        ' ',
	        'and is hosted at',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://www.netlify.com',
	          text: 'Netlify',
	          external: true
	        }),
	        '. The theme is based on',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: 'https://github.com/lowmess/lowmess/commit/ba1fa470f434bb2f5b393eef9d269247e154b22d',
	          text: 'Alec Lomas\'',
	          external: true
	        }),
	        ' ',
	        'portfolio website. You can learn more about the individual components used for the implementation as well as about the development and infrastructure tools in the',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/colophon/', text: 'colophon' }),
	        '.'
	      ),
	      _react2.default.createElement(
	        _Typography.Paragraph,
	        { fontSize: [1, 2], lineHeight: 'copy', mt: 0, mb: 3 },
	        _react2.default.createElement(
	          'b',
	          null,
	          'Legal Notice and Privacy Policy'
	        ),
	        _react2.default.createElement('br', null),
	        'This site has a',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/legal_notice/', text: 'legal notice (English)' }),
	        ' and an',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/impressum/', text: 'Impressum (Deutsch)' }),
	        ' as well as a',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, { to: '/privacy_policy/', text: 'privacy policy (English)' }),
	        ' and a',
	        ' ',
	        _react2.default.createElement(_StyledLink.StyledLink, {
	          to: '/datenschutz_erklaerung/',
	          text: 'Datenschutzerkl\xE4rung (Deutsch)'
	        }),
	        '.'
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = AboutPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-eeb3687fa14596d0cbea.js